__webpack_require__.p = "https://micro-react.pages.dev/";